/* eslint-disable */
import React from 'react';
import { useIntl } from '@lumahealthhq/ui-components';
import { Box, Button, IconInfoOutlined, IconRefresh, Link, Typography } from '@lumahealthhq/ui-core';
import { useCurrentUser } from '@lumahealthhq/ui-model';
import { useZendeskSSO } from '../TODO/ui-model';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ErrorBoundaryMessage(_ref) {
  var onClick = _ref.onClick;
  var currentUser = useCurrentUser();
  var intl = useIntl();
  var _useZendeskSSO = useZendeskSSO(),
    zendeskSSO = _useZendeskSSO.mutate,
    isLoading = _useZendeskSSO.isLoading;
  var zendeskUser = React.useMemo(function () {
    var _currentUser$firstnam, _currentUser$lastname, _currentUser$email;
    return {
      name: "".concat((_currentUser$firstnam = currentUser == null ? void 0 : currentUser.firstname) != null ? _currentUser$firstnam : '', " ").concat((_currentUser$lastname = currentUser == null ? void 0 : currentUser.lastname) != null ? _currentUser$lastname : ''),
      email: (_currentUser$email = currentUser == null ? void 0 : currentUser.email) != null ? _currentUser$email : ''
    };
  }, [currentUser]);
  var handleReportClick = React.useCallback(function () {
    if (isLoading) return;
    zendeskSSO({
      user: zendeskUser,
      zendeskURL: 'https://support.lumahealth.io/hc/en-us/requests/new'
    });
  }, [zendeskUser, zendeskSSO, isLoading]);
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      alignItems: 'center',
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '100%',
      p: 1,
      width: '100%'
    },
    children: [/*#__PURE__*/_jsx(IconInfoOutlined, {
      sx: {
        color: 'grey.600'
      }
    }), /*#__PURE__*/_jsx(Typography, {
      component: "p",
      variant: "h5",
      gutterBottom: true,
      children: intl.formatMessage({
        id: "/WMCDd",
        defaultMessage: [{
          "type": 0,
          "value": "Something went wrong!"
        }]
      })
    }), /*#__PURE__*/_jsxs(Typography, {
      variant: "body1",
      sx: {
        mb: 3
      },
      children: [intl.formatMessage({
        id: "f0kXpv",
        defaultMessage: [{
          "type": 0,
          "value": "Please try again. If the issue persists, you can report it"
        }]
      }), ' ', /*#__PURE__*/_jsx(Link, {
        onClick: handleReportClick,
        children: intl.formatMessage({
          id: "hniz8Z",
          defaultMessage: [{
            "type": 0,
            "value": "here"
          }]
        })
      }), "."]
    }), /*#__PURE__*/_jsxs(Button, {
      disabled: isLoading,
      variant: "primary",
      sx: {
        height: '40px'
      },
      onClick: onClick,
      children: [/*#__PURE__*/_jsx(IconRefresh, {
        fontSize: "small",
        sx: {
          mr: 1
        }
      }), intl.formatMessage({
        id: "jsy7pk",
        defaultMessage: [{
          "type": 0,
          "value": "Try Again"
        }]
      })]
    })]
  });
}